<div class="mainContainer">
    <div class="filter_show">
        <h2 class="log_track">
            {{ viewMode === 'monthly' ? 'Mess Daysheet Overview' : 'Pending Mess Inventory Details' }}
        </h2>
    </div>

    <div class="mess-box">
        <div class="mess-toolbar-row">
            <div class="view-tabs" role="tablist" aria-label="View mode">
                <button type="button" class="view-tab" role="tab" [class.view-tab--active]="viewMode === 'monthly'"
                    [attr.aria-selected]="viewMode === 'monthly'" (click)="setViewMode('monthly')">
                    Month Wise Overview
                </button>
                <button type="button" class="view-tab" role="tab" [class.view-tab--active]="viewMode === 'pending'"
                    [attr.aria-selected]="viewMode === 'pending'" (click)="setViewMode('pending')">
                    Pending Details
                </button>

            </div>

            <div class="overview-date-picker" *ngIf="viewMode === 'monthly'">
                <span class="overview-date-picker__label">Select date</span>
                <div class="overview-date-picker__wrap">
                    <div class="overview-date-picker__field">
                        <input
                            type="text"
                            class="overview-date-picker__input form-control"
                            [value]="monthLabel"
                            readonly
                            (click)="toggleOverviewPicker($event)"
                            aria-label="Selected month and year" />
                        <button
                            type="button"
                            class="overview-date-picker__icon-btn"
                            (click)="toggleOverviewPicker($event)"
                            [attr.aria-expanded]="overviewPickerOpen"
                            aria-label="Open year and month selection">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.89 4 3 4.9 3 6v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="currentColor"/>
                            </svg>
                        </button>
                    </div>
                    <div
                        class="overview-picker-card"
                        *ngIf="overviewPickerOpen"
                        role="dialog"
                        aria-label="Select year and month"
                        (click)="$event.stopPropagation()">
                        <div class="overview-picker-card__header">
                            <button
                                type="button"
                                class="overview-picker-card__nav"
                                *ngIf="overviewPickerView === 'year'"
                                (click)="prevYearPage()"
                                aria-label="Previous years">‹</button>
                            <button
                                type="button"
                                class="overview-picker-card__year-btn"
                                *ngIf="overviewPickerView === 'month'"
                                (click)="showYearPickerView()"
                                aria-label="Change year">
                                {{ pickerYear }}
                            </button>
                            <span class="overview-picker-card__range" *ngIf="overviewPickerView === 'year'">
                                {{ yearPageStart }} – {{ yearPageEnd }}
                            </span>
                            <button
                                type="button"
                                class="overview-picker-card__nav"
                                *ngIf="overviewPickerView === 'year'"
                                (click)="nextYearPage()"
                                aria-label="Next years">›</button>
                        </div>

                        <div class="overview-picker-card__years" *ngIf="overviewPickerView === 'year'">
                            <button
                                type="button"
                                class="overview-picker-card__cell"
                                *ngFor="let y of yearPageYears"
                                [class.overview-picker-card__cell--active]="y === pickerYear"
                                (click)="selectPickerYear(y)">
                                {{ y }}
                            </button>
                        </div>

                        <div class="overview-picker-card__months" *ngIf="overviewPickerView === 'month'">
                            <button
                                type="button"
                                class="overview-picker-card__cell"
                                *ngFor="let m of monthPickerOptions"
                                [class.overview-picker-card__cell--active]="m.value === pickerMonth"
                                (click)="selectPickerMonth(m.value)">
                                {{ m.label }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="summary-cards" *ngIf="viewMode === 'monthly'">
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--closed" aria-hidden="true">
                        <i class="fa-solid fa-clipboard-check"></i>
                    </span>
                    <span class="summary-card__title">Closed</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.closed }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('closed')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('closed')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('closed') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.closed) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--pending" aria-hidden="true">
                        <i class="fa-solid fa-clock"></i>
                    </span>
                    <span class="summary-card__title">Pending </span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.pending }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('pending')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('pending')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('pending') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.pending) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--not-submitted" aria-hidden="true">
                        <i class="fa-solid fa-circle-minus"></i>
                    </span>
                    <span class="summary-card__title">Not Submitted</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.notSubmitted }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('notSubmitted')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('notSubmitted')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('notSubmitted') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.notSubmitted) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--holiday" aria-hidden="true">
                        <i class="fa-solid fa-ban"></i>
                    </span>
                    <span class="summary-card__title">Holiday</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.holiday }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('holiday')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('holiday')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('holiday') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.holiday) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--total" aria-hidden="true">
                        <i class="fa-solid fa-building"></i>
                    </span>
                    <span class="summary-card__title">Total Campuses</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ totalCampuses }}</span>
                    <span class="summary-card__trend"
                        [class.summary-card__trend--up]="isSummaryTrendUp('totalCampuses')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('totalCampuses')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('totalCampuses') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        Active
                    </span>
                </div>
            </article>
        </div>

        <!-- <div class="icon_flex">
            <p class="search_title">Search :</p>
            <input #searchInputcampus type="text" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input" />
        </div> -->

        <div class="month-legend" *ngIf="viewMode === 'monthly'">
            <span class="month-legend__item"><span class="month-legend__swatch month-legend__swatch--closed"></span>
                Closed</span>
            <span class="month-legend__item"><span class="month-legend__swatch month-legend__swatch--pending"></span>
                Pending </span>
            <span class="month-legend__item"><span
                    class="month-legend__swatch month-legend__swatch--not-submitted"></span> Not Submitted</span>
            <span class="month-legend__item"><span class="month-legend__swatch month-legend__swatch--holiday"></span>
                Holiday</span>
        </div>

        <div #monthlyGridWrap class="content monthly-grid-wrap"
            [class.monthly-grid-wrap--active]="viewMode === 'monthly'" style="width: 100%; height: 40%;">
            <ag-grid-angular style="width: 100%; height: 400px;" [rowData]="activeRowData" [columnDefs]="activeColDefs"
                [defaultColDef]="activeDefaultColDef" [gridOptions]="activeGridOptions"
                (gridReady)="onGridReady($event)" [rowHeight]="viewMode === 'monthly' ? 42 : 45"
                [headerHeight]="viewMode === 'monthly' ? 50 : undefined" [quickFilterText]="quickFilter"
                [overlayLoadingTemplate]="overlayLoadingTemplate" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                (rowClicked)="onRowClicked($event)" (cellClicked)="onCellClicked($event)"
                [rowStyle]="{ cursor: 'pointer' }" />
        </div>
    </div>
</div>
<!-- loader -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>